import { GlobalStyles } from '@mui/material';
import * as React from 'react';

export const DefaultGlobalStyles = () => {
  return (
    <GlobalStyles
      styles={{
        '*, *::before, *::after': {
          boxSizing: 'border-box',
        },
        '*::-webkit-scrollbar-track-piece': {
          backgroundColor: 'transparent',
          borderRadius: 0,
        },
        '*::-webkit-scrollbar': {
          width: '8px',
          height: '8px',
        },
        '*::-webkit-scrollbar-thumb': {
          height: '50px',
          backgroundColor: 'rgba(0,0,0,0.3)',
          borderRadius: '4px',
          outlineOffset: '-2px',
        },
        '*::-webkit-scrollbar-thumb:hover': {
          height: '50px',
          backgroundColor: '#9f9f9f',
          borderRadius: '4px',
        },
        'html, body': {
          margin: 0,
          height: '100%',
          minWidth: 320,
          overflowY: 'hidden', // TODO: find a different solution for double scrollbars in /my-workspace
          backgroundColor: '#fafafa',
          fontFamily: 'arial, helvetica, sans-serif',
        },
        '#root': {
          height: '100%',
        },
      }}
    />
  );
};

// Override default min width for desktop
export const DesktopGlobalStyles = () => {
  return (
    <GlobalStyles
      styles={{
        'html, body': {
          minWidth: '1200px',
        },
      }}
    />
  );
};

// Override default overflow & background for embedded views
export const EmbeddedGlobalStyles = () => {
  return (
    <GlobalStyles
      styles={{
        'html, body': {
          overflow: 'auto',
          backgroundColor: '#fff',
        },
      }}
    />
  );
};
